<script>
  /** @typedef Props
   * @property { Object[] } data
   * @property { String[] } cols
   * @property { String[] } colLabels
   * @property { function[] } colFormats */
  /** @type {Props} */
  let { data, cols, colFormats, colLabels } = $props();

  let columns = $state(cols ? cols : data.length > 0 ? Object.keys(data[0]) : undefined);
</script>

<div class="info-table-wrapper">
  {#if data && columns}
    <table>
      <thead>
        <tr>
          {#each columns as column, i}
            <th class={i == 0 ? "sticky" : ""}>{colLabels[i]}</th>
          {/each}
        </tr>
      </thead>
      <tbody>
        {#each data as row, i (i)}
          <tr>
            {#each columns as column, i}
              {#if i > 0}
                <td
                  >{row[column] == "NA"
                    ? "NA"
                    : colFormats[i]
                      ? colFormats[i].format(row[column])
                      : row[column]}</td
                >
              {:else}
                <td class="sticky">{@html row[column]}</td>
              {/if}
            {/each}
          </tr>
        {/each}
      </tbody>
    </table>
  {/if}
</div>

<style>
  .info-table-wrapper {
    width: 100%;
    overflow-x: auto;
  }
  .info-table-wrapper:not(:first-child) {
    margin-top: var(--spacing-8);
  }
  /* table */
  table {
    border-spacing: 0;
    font-size: var(--font-size-small);
    margin: 0;
    width: 100%;
    overflow-x: scroll;
  }

  /*** TABLE HEADER ***/
  thead tr:first-child th {
    text-align: right;
    border-bottom: 2px solid var(--color-black);
    padding-bottom: var(--spacing-3);

    vertical-align: bottom;
    font-weight: 900;
  }

  thead th {
    background-color: white;
    min-width: 100px;
  }

  /* all first table header left right*/
  thead tr:first-child th:first-child {
    text-align: left;
  }

  /* all first table header left right*/
  thead tr:first-child th:not(:first-child) {
    padding-left: var(--spacing-3);
  }

  /*** TABLE BODY ***/
  tbody tr td {
    padding: var(--spacing-2) var(--spacing-1);
    border-bottom: 2px solid var(--color-gray);
    background-color: white;
  }

  tbody tr td:first-child {
    padding-left: 0;
    text-align: left;
  }

  tbody tr td:not(:first-child) {
    text-align: right;
  }

  tbody tr td:last-of-type {
    font-weight: 700;
  }

  td {
    color: var(--color-gray-shade-darkest);
    word-break: break-word;
  }
  thead tr th:nth-child(1) {
    min-width: 38vw;
  }

  .sticky {
    position: sticky;
    left: 0;
    z-index: 2;
    tbody & {
      border-right: 2px solid var(--color-gray);
    }
  }

  @media (min-width: 768px) {
    thead tr th:nth-child(1) {
      min-width: 22vw;
    }
  }
  @media (min-width: 1200px) {
    thead tr th:nth-child(1) {
      min-width: 14.5rem;
    }

    /* td { */
    /*   min-width: 9rem; */
    /* } */
  }
</style>
